import { apiClient } from '../../../client'

export type InstoreShiftItem = {
  shift_name: string
  checkin: string
  checkout: string
  working_hours: number
}

export type InstoreHoursRow = {
  report_date: string
  region: string
  city: string
  user: string
  username: string
  report_to: string
  total_instore_hours: number
  shifts: InstoreShiftItem[]
}

export type InstoreHoursFilters = {
  region_ids?: string
  city_ids?: string
  user_ids?: string
  report_to_ids?: string
}

export type InstoreHoursResponse = {
  max_shift_count: number
  data: InstoreHoursRow[]
}

class InstoreHoursRepository {
  private buildParams(
    startDate: string,
    endDate: string,
    filters?: InstoreHoursFilters,
  ): URLSearchParams {
    const params = new URLSearchParams({
      start_date: startDate,
      end_date: endDate,
    })
    if (filters?.region_ids) params.set('region_ids', filters.region_ids)
    if (filters?.city_ids) params.set('city_ids', filters.city_ids)
    if (filters?.user_ids) params.set('user_ids', filters.user_ids)
    if (filters?.report_to_ids) params.set('report_to_ids', filters.report_to_ids)
    return params
  }

  async getInstoreHours(
    startDate: string,
    endDate: string,
    filters?: InstoreHoursFilters,
  ): Promise<InstoreHoursResponse> {
    const params = this.buildParams(startDate, endDate, filters)
    return apiClient.get<InstoreHoursResponse>(`/instore-hours?${params.toString()}`)
  }

  async exportInstoreHours(
    startDate: string,
    endDate: string,
    filters?: InstoreHoursFilters,
  ): Promise<Blob> {
    const params = this.buildParams(startDate, endDate, filters)
    return apiClient.getBlob(`/instore-hours/export?${params.toString()}`)
  }
}

export const instoreHoursRepository = new InstoreHoursRepository()
